import { Sagas } from './types'

import systemConfigurationSagas from './system-configuration/sagas'

export const getStaticSagas = (): Sagas => []

export const getCoreSagas = (): Sagas => [systemConfigurationSagas()]
